var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.ScheduleType==1)?_c('brandNewIndex',{attrs:{"params":_vm.params}}):(_vm.ScheduleType==2)?_c('newindex',{attrs:{"params":_vm.params}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }